import {EValidationTestType} from "../../../utils/validationConfigs";

export const formConfig = {
    register: {
        phoneNumber: {
            model: "register",
            name: "phoneNumber",
            standardMessage: undefined,
            validationTests: [
                EValidationTestType.hasValue,
                EValidationTestType.isPhoneNumber
            ],
            visible: true,
            showSuccess: true,
        },
    },
};
